import { UserRole } from 'gql/types';
import { useCurrentUser } from 'modules/user/hooks/useCurrentUser';

import { useRecruiterDashboardSettings } from './useRecruiterDashboardSettings';

/**
 * Hook to check if the current user has access to the Recruiter Dashboard
 * based on role-based restrictions in settings.
 */
export function useRecruiterDashboardAccess() {
  const { data: currentUser } = useCurrentUser();
  const { settings, loading } = useRecruiterDashboardSettings();

  const userRole = currentUser?.role?.value as UserRole | undefined;

  // Check if dashboard is hidden for this role
  const isHidden =
    settings?.roleRestrictionsEnabled &&
    userRole &&
    settings.roleRestrictions[userRole]?.hideDashboard === true;

  return {
    hasAccess: !isHidden,
    loading,
  };
}
